import React from 'react';
import { styled } from 'styled-components';
import OptionList from './OptionList';
import mySearchOptionService from '../../../service/mySearchOption/mySearchOption';

interface OptionType {
  count: number;
  date: string;
  p_idx: number;
  param: string;
  save_type: string;
  title: string;
}

interface Props {
  option: OptionType;
  onClose: () => void;
  getSearchOptionList: () => void;
}

function DeleteModal({ option, onClose, getSearchOptionList }: Props) {
  const deleteOption = async () => {
    try {
      const result = await mySearchOptionService.delete(option.p_idx);
      if (result.status === 'success') {
        alert('삭제되었습니다.');
        getSearchOptionList();
        onClose();
      }
    } catch (e) {
      alert('삭제에 실패했습니다.');
    }
  };
  return (
    <ModalOverlay
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClose();
      }}
    >
      <ModalContainer
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <Box>
          {option.title}을 삭제하시겠습니까?
          <OptionList data={option.param} />
        </Box>
        <ButtonBox>
          <DeleteButton onClick={deleteOption}>삭제</DeleteButton>
          <CancleButton onClick={onClose}>취소</CancleButton>
        </ButtonBox>
      </ModalContainer>
    </ModalOverlay>
  );
}

export default DeleteModal;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
  z-index: 2000;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

const ModalContainer = styled.div<{ option?: string }>`
  width: 100%;
  background-color: #ffffff;
  overflow: hidden;
  box-shadow: 0px 4px 15px 0px #8d95a340;
  border: 1px solid #e1e2e4;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;

  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Box = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 0;

  font-weight: 700;
  font-size: 18px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: #222222;
`;

const ButtonBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;

const DeleteButton = styled.div`
  width: 100%;
  border: 1px solid #d84836;
  padding: 12px 28px;
  border-radius: 8px;

  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: #d84836;
`;

const CancleButton = styled.div`
  width: 100%;
  padding: 12px 28px;
  border-radius: 8px;
  background-color: #70737c14;

  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: #616161;
`;
